import {Component, OnInit, ViewChild} from '@angular/core';
import {FormArray, FormControl, FormGroup} from '@angular/forms';
import {StepData, SwitchCaseNode, SwitchCaseNodeFormType} from './switchCase';
import {EditPermissions, NodeBuilder, NodeFlowDetails} from '../../../../../../../shared/models';
import {swalMini} from '../../../../../../../shared/utils/utils';
import {moveItemInArray} from '@angular/cdk/drag-drop';
import {MatAccordion} from '@angular/material/expansion';
import map from 'lodash/map';

const NODE_TYPE = 'switchCase';

@Component({
  selector: 'app-switch-case',
  templateUrl: './switch-case.component.html',
  styleUrls: ['./switch-case.component.scss']
})
export class SwitchCaseComponent extends NodeBuilder implements OnInit {

  @ViewChild('accordion') Accordion: MatAccordion;
  @ViewChild('Accord') Accordion2: MatAccordion;
  actionParams: FormGroup;
  actionResults: FormGroup;
  canEdit: EditPermissions;
  nodeFlowDetails: NodeFlowDetails;
  caseToggle = false;
  CollapseExpand = true;
  resultsFirstStep = null;
  private stepUniqueID =  '';

  ngOnInit(): void {
  }

  constructor() {
    super(NODE_TYPE);
  }

  get optionsList(): FormArray {
    return this.actionResults.controls['options'] as FormArray;
  }

  drop(event: any) {
    const Case = this.optionsList.value;
    moveItemInArray(Case, event.previousIndex, event.currentIndex);
    this.optionsList.patchValue(Case);
  }

  toggle() {
    this.actionParams.controls['isCaseSensitive'].patchValue(this.caseToggle);
    this.caseToggle = !this.caseToggle;
  }

  remove(index: number) {
    if (this.optionsList.length === 1) {
      swalMini({title: 'At least one option is needed', type: 'error'});
    }
    if (this.optionsList.length > 1) {
      this.optionsList.removeAt(index);
    }
  }

  ExpandCollapseAll() {
    if (this.CollapseExpand) {
        this.CollapseExpand = false;
        this.Accordion.closeAll();
        this.Accordion2.closeAll();
    } else {
      this.CollapseExpand = true;
      this.Accordion.openAll();
      this.Accordion2.openAll();
    }
  }

  get getStepData(): {} {
    const actionParams = this.actionParams.getRawValue();
    let actionResults = this.actionResults.getRawValue();
    const switchCaseNode = new SwitchCaseNode(this.nodeType);

    if (!this.resultsFirstStep ) {
      this.resultsFirstStep = this.getNextStep();
    } else {
      actionResults = this.patchInitialResultsStepNumber(actionResults);
    }

    switchCaseNode.addActionDetails(actionParams.name, actionParams.description);
    switchCaseNode.addActionParams(actionParams.variable, actionParams.isCaseSensitive);
    switchCaseNode.addActionResults(actionResults);

    const nodeData = switchCaseNode.nodeData;
    if (this.stepUniqueID !== '') {
      nodeData['metadata'].stepUniqueID = this.stepUniqueID;
    }

    return nodeData;
  }

  get isNodeValid(): boolean {
    this.actionParams.markAllAsTouched();
    this.actionResults.markAllAsTouched();

    if (this.actionParams.value && this.actionResults.value) {
      return (this.actionParams.valid && this.actionResults.valid);
    }
  }

  set buildForm(stepData: StepData) {
    this.stepUniqueID = stepData.metadata?.stepUniqueID ? stepData.metadata?.stepUniqueID : '';
    const formData: SwitchCaseNodeFormType = SwitchCaseNode.toForm(stepData);
    if (!stepData) {
      return;
    }
    this.buildActionParamsForm(formData);
    this.buildActionResultsForm(formData);
  }

  private patchInitialResultsStepNumber(results) {
    const options = map(results.options, (option) => {
      return {
        ...option,
        step: this.setResultStep(option.step)
      };
    });
    return {
      options,
      other: this.setResultStep(results.other)
    };
  }

  setResultStep(step) {
    let updatedStep = step;
    if (step === 'NextStep') {
      updatedStep = 'step' + this.resultsFirstStep;
      this.resultsFirstStep++;
    }
    return updatedStep;
  }

  buildActionParamsForm(formData) {
    this.actionParams = SwitchCaseNode.getActionTemplate(this.canEdit);
    this.actionParams.patchValue(formData.actionParams);
  }

  buildActionResultsForm(formData) {
    this.actionResults = new FormGroup({
      options: new FormArray([]),
      other: new FormControl('')
    });

    const OptionArr = this.actionResults.get('options') as FormArray;
    this.addOption(OptionArr, formData.actionResults.options);
    this.actionResults.get('other').patchValue(formData.actionResults.other);
  }

  addOption(options, data) {
    for (let i = 0; i < data.length; i++) {
      this.addCase();
    }
    options.patchValue(data);
    }

  addCase(): void {
    this.optionsList.push(SwitchCaseNode.getCaseTemplate(this.canEdit));
  }
}
